export function ensureLuxPlusBenefitTitle<T extends App.OfferSubscriptionBenefitItem>(benefit: T): T & { title: string } {
  return {
    ...benefit,
    title: benefit.title ?? benefit.shortTitle ?? benefit.description ?? benefit.type,
  }
}
